import { Lock } from 'lucide-react'
import { Link } from 'react-router-dom'

/**
 * Shown in place of a premium page when the selected hotel is on the free plan.
 * The feature unlocks for everyone in the hotel once an owner upgrades to Tier 1.
 */
export function PremiumLocked({ featureName }: { featureName?: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-app dark:bg-app-dark p-4 transition-colors duration-300">
      <div className="max-w-md w-full bg-surface dark:bg-surface-dark shadow-2xl rounded-[2rem] p-8 text-center border border-border-subtle dark:border-border-subtle-dark">
        <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-3xl bg-amber-500/10 dark:bg-amber-500/20 mb-6">
          <Lock className="h-10 w-10 text-amber-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 tracking-tight">
          {featureName ? `${featureName} is a Tier 1 feature` : 'This is a Tier 1 feature'}
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mb-8">
          This page is available on hotels with a paid (Tier 1) plan. Once an owner of this hotel
          upgrades, it unlocks automatically for everyone on the team.
        </p>
        <Link
          to="/dashboard"
          className="btn-primary inline-flex items-center justify-center px-6 py-3 rounded-xl"
        >
          Back to Dashboard
        </Link>
      </div>
    </div>
  )
}
